export default {"src":"/_next/static/media/stripe-text.52cb065a.svg","height":14,"width":34,"blurWidth":0,"blurHeight":0};